import { useEffect, useState } from 'react'
import ReservationBoxCheckout from './ReservationBoxCheckout'
import { PaymentAPI } from '../../api/PaymentAPI'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import scheduleImg from '../../assets/images/schedule_1.png'
import { Button } from '@mui/material'
import { rootAction } from '../../redux/reducer/rootReducer'
import Loader from '../../component/Loader'
import { CoachSchedulerAPI } from '../../api/CoachSchedulerAPI'
import { AccountSetupAPI } from '../../api/AccountSetupAPI'

const ScheduleCartDetails = () => {
    document.title = "Reservation Checkout"
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [checkoutDetails, setCheckoutDetails] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loadingCount, setLoadingCount] = useState(0);
     const [isCustomerPayFee, setIsCustomerPayFee] = useState(false);

    const [isUpdate, setIsUpdate] = useState(false);

    const startLoading = () => {
        setLoadingCount(prevCount => prevCount + 1);
    };
    const finishLoading = () => {
        setLoadingCount(prevCount => prevCount - 1);
    };

    useEffect(() => {
        if (selectedClub.clubId && userInfo.userId) {
            findIsCustomerPayProcessingFee();
            calculatePricing();
        }
        isUpdate && setIsUpdate(false);
    }, [userInfo.userId, selectedClub.clubId, isUpdate])

    const calculatePricing = async () => {
        try {
            const paymentInfo = {
                userId: userInfo.userId,
                clubId: selectedClub.clubId
            }
            startLoading();
            const response = await PaymentAPI.postCalculateEventSchedulePricing(paymentInfo);
            setCheckoutDetails(response.Data);
        } catch (error) {
            console.error(error);
        } finally {
            finishLoading();
        }

    }
     const findIsCustomerPayProcessingFee = async () => {
            try {
                const response = await AccountSetupAPI.getAccountSetupIaCustomerPayFee(selectedClub.clubId);
                setIsCustomerPayFee(response.Data);
        
                
            } catch (error) {
                console.log(error);
            }
        };
    const handleConfirmFreeReservation = async () => {
        try {
            startLoading();
            const response = await CoachSchedulerAPI.putConfirmFreeSchedule({ userId: userInfo.userId, clubId: selectedClub.clubId });
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Reservation confirmed successfully.' }));
            setIsUpdate(true);
            setTimeout(() => {
                dispatch(rootAction.setIsUpdateTotalSchedule(true));
            }, 1000);
        } catch (error) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Something went wrong' }));
        } finally {
            finishLoading();
        }
    }

    const handleCheckout = async () => {

        if (checkoutDetails?.warning) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: checkoutDetails?.warning }));
            return;
        }

        if (checkoutDetails?.totalAmount === '0.00') {
            handleConfirmFreeReservation();
            return;
        }
        try {
            const paymentDetails = {
                userId: userInfo.userId,
                paymentCreatedBy: userInfo.userId,
                clubId: selectedClub.clubId,
                amount: checkoutDetails?.totalAmount,
                paymentType: "onSchedulePayment"
            }
            startLoading();
            const paymentIntentResponse = await PaymentAPI.postCreatePaymentIntent(paymentDetails);
            dispatch(rootAction.setPaymentIntentId(paymentIntentResponse.Data.paymentIntentId));
            finishLoading();
            navigate('/payment', {
                state: {
                    clientSecret: paymentIntentResponse.Data.paymentIntentClientSecret,
                    paymentIntentId: paymentIntentResponse.Data.paymentIntentId,
                    reservationFor: paymentDetails.userId,
                    priceDetails: {
                        totalHour: checkoutDetails?.totalHour,
                        totalReservations: checkoutDetails?.totalReservations,
                        totalAmount: paymentIntentResponse.Data.totalAmount,
                        processingFee: paymentIntentResponse.Data.processingFee,
                    }
                }
            })
        } catch (error) {
            finishLoading();
        }
    }



    if (loadingCount > 0) {
        return <Loader />
    }

    return (
        <div className='cart_page_container'>
            {checkoutDetails && checkoutDetails.schedules.length != 0
                ?
                <>
                    <div className="reservation_details_for_checkout" >
                        <h1>Schedule Details:</h1>

                        {checkoutDetails?.schedules?.map((item) =>
                            <ReservationBoxCheckout
                                key={item.reservationId}
                                selectedClub={selectedClub}
                                startLoading={startLoading}
                                finishLoading={finishLoading}
                                isReservation={false}
                                schedule={item}
                                setIsUpdate={setIsUpdate}
                            />
                        )}
                    </div>
                    <div className="reservation_price_detals_body">
                        <h1>Price Details</h1>
                        <div className="reservation_price_detals_row">
                            <p>{Number(checkoutDetails?.totalReservations) > 1 ? 'Total Reservations' : 'Total Reservation'}</p>
                            <p>{checkoutDetails?.totalReservations}</p>
                        </div>
                        <div className="reservation_price_detals_row">
                            <p>{Number(checkoutDetails?.totalHour) > 1 ? 'Total Hours' : 'Total Hour'}</p>
                            <p>{checkoutDetails?.totalHour}</p>
                        </div>
                       {isCustomerPayFee &&
                        <div className="reservation_price_detals_row">
                            <p>Processing Fee</p>
                            <p>Pending</p>
                        </div>}
                        <div className="reservation_horizontal_line"></div>
                        <div className="reservation_price_detals_row">
                           {isCustomerPayFee ?
                            <p>Gross Amount:</p>
                           :
                            <p>Total Amount:</p>}
                            <p>${checkoutDetails?.totalAmount}</p>
                        </div>
                        <button onClick={handleCheckout}>checkout</button>
                    </div>
                </>
                :
                <div className='checkout_reservation_not_found'>
                    <img src={scheduleImg} alt="" />
                    <h1>Schedules for checkout were not found.</h1>
                    <Button onClick={() => {
                        navigate('/coach-scheduler');
                        dispatch(rootAction.setSlideBarLink('calendar'));
                    }} variant='contained'>Book schedule</Button>
                </div>}
        </div>
    )
}

export default ScheduleCartDetails